import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(
    items: any[],
    value: any = undefined,
    fieldName: string = undefined,
    innerFieldName: string = undefined
  ): any[] {
    if (!items || (items && !items.length)) {
      return [];
    }
    if (value === undefined) {
      return items;
    }

    if (!!fieldName) {
      if (!!innerFieldName) {
        return items.filter(item => {
          if (item && item[fieldName] && item[fieldName][innerFieldName]) {
            return item[fieldName][innerFieldName] === value;
          }
          return false;
        });
      } else {
        return items.filter(item => {
          if (item) {
            return item[fieldName] === value;
          }
          return false;
        });
      }
    } else {
      return items.filter(item => {
        return item === value;
      });
    }
  }
}
